/**
 * 对象工具
 */
class ObjectTools {
    /**
     * 对象或数组深拷贝
     * @param obj
     * @param deep
     * @returns {{}|*[]|*}
     */
    deepCopy(obj, deep) {
        if (obj instanceof Array) {
            return [...obj]
        } else if (obj instanceof Object) {
            if (deep) {
                let obj2 = {}
                for (let key in obj) {
                    let child = obj[key]
                    if (child instanceof Array) {
                        obj2[key] = this.deepCopy(obj[key], deep)
                    } else if (child instanceof Object) {
                        obj2[key] = this.deepCopy(obj[key], deep)
                    } else {
                        obj2[key] = obj[key]
                    }
                }
                return obj2
            } else {
                return { ...obj }
            }
        } else {
            return obj
        }
    }


    /**
     * 对象或数组合并
     * @param obj1
     * @param obj2
     * @returns {*[]|*}
     */
    merge (obj1, obj2) {
        if (Array.isArray(obj1)) {
            return [...obj1, ...obj2]
        } else if (obj1 instanceof Object){
            let objResult = this.deepCopy(obj1, true)
            let objTemp = this.deepCopy(obj2, true)
            for (let key in objTemp) {
                if (objTemp.hasOwnProperty(key)){
                    objResult[key] = objTemp[key]
                }
            }
            return objResult
        } else {
            throw '无法合并非引用了类型对象'
        }
    }

    /**
     * 在数组中查找指定值，并返回它的索引值（如果没有找到，则返回-1）
     * @param elem 任意类型 用于查找的值。
     * @param arr Array类型 指定被查找的数组。
     * @param i 可选。Number类型 指定从数组的指定索引位置开始查找，默认为 0
     * @returns {number}
     */
    inArray ( elem, arr, i ) {
        return arr == null ? -1 : [].indexOf.call( arr, elem, i );
    }

    extend () {
        let options, name, src, copy, copyIsArray, clone,
            target = arguments[0] || {},
            i = 1,
            length = arguments.length,
            deep = false

        // Handle a deep copy situation
        if ( typeof target === "boolean" ) {
            deep = target;

            // Skip the boolean and the target
            target = arguments[ i ] || {};
            i++;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if ( typeof target !== "object" && typeof target !== "function" ) {
            target = {};
        }

        // Extend jQuery itself if only one argument is passed
        if ( i === length ) {
            target = this;
            i--;
        }

        for ( ; i < length; i++ ) {

            // Only deal with non-null/undefined values
            if ( ( options = arguments[ i ] ) != null ) {

                // Extend the base object
                for ( name in options ) {
                    copy = options[ name ];

                    // Prevent Object.prototype pollution
                    // Prevent never-ending loop
                    if ( name === "__proto__" || target === copy ) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                        ( copyIsArray = Array.isArray( copy ) ) ) ) {
                        src = target[ name ];

                        // Ensure proper type for the source value
                        if ( copyIsArray && !Array.isArray( src ) ) {
                            clone = [];
                        } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
                            clone = {};
                        } else {
                            clone = src;
                        }
                        copyIsArray = false;

                        // Never move original objects, clone them
                        target[ name ] = this.extend( deep, clone, copy );

                        // Don't bring in undefined values
                    } else if ( copy !== undefined ) {
                        target[ name ] = copy;
                    }
                }
            }
        }

        // Return the modified object
        return target;
    }

    /**
     * 用于判断指定参数是否是一个纯粹的对象
     * 所谓"纯粹的对象"，就是该对象是通过"{}"或"new Object"创建的
     * @param obj 需要进行判断的任意值
     * @returns {boolean|boolean}
     */
    isPlainObject ( obj ) {
        let proto, Ctor;

        // Detect obvious negatives
        // Use toString instead of jQuery.type to catch host objects
        if ( !obj || toString.call( obj ) !== "[object Object]" ) {
            return false;
        }

        proto = getProto( obj );

        // Objects with no prototype (e.g., `Object.create( null )`) are plain
        if ( !proto ) {
            return true;
        }

        // Objects with prototype are plain iff they were constructed by a global Object function
        Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
        return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
    }

    /**
     * 函数用于判断指定参数是否是一个数字值
     * @param obj
     * @returns {boolean|boolean}
     */
    isNumeric ( obj ) {
        return !isNaN( parseFloat( obj ) ) && isFinite( obj );
    }
}

export default ObjectTools

export const fnToString = function (){
    return {}.hasOwnProperty.toString
}
export const ObjectFunctionString = function (){
    return fnToString.call( Object )
}

